export const ACTION_RESET = 'FETCH_HOMESTORY_RESET';
export const ACTION_REQUEST = 'FETCH_HOMESTORY_REQUEST';
export const ACTION_SUCCESS = 'FETCH_HOMESTORY_SUCCESS';
export const ACTION_ERROR = 'FETCH_HOMESTORY_ERROR';
